'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

const UTM_PARAMETER_KEYS = [
  'utm_medium',
  'utm_source',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const

export const UtmParameterStorage = () => {
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!searchParams) return

    UTM_PARAMETER_KEYS.forEach((key) => {
      const value = searchParams.get(key)
      if (value) {
        localStorage.setItem(key, value)
      }
    })
  }, [searchParams])

  return null
}
